/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dropvouchernoteplaceholder3Inputs */

const en_dropvouchernoteplaceholder3 = /** @type {(inputs: Dropvouchernoteplaceholder3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`One drink of choice up to €5. Show ID for alcohol.`)
};

const de_dropvouchernoteplaceholder3 = /** @type {(inputs: Dropvouchernoteplaceholder3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ein Getränk nach Wahl bis 5 €. Bei Alkohol Ausweis zeigen.`)
};

/**
* | output |
* | --- |
* | "One drink of choice up to €5. Show ID for alcohol." |
*
* @param {Dropvouchernoteplaceholder3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const dropvouchernoteplaceholder3 = /** @type {((inputs?: Dropvouchernoteplaceholder3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dropvouchernoteplaceholder3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dropvouchernoteplaceholder3(inputs)
	return de_dropvouchernoteplaceholder3(inputs)
});
export { dropvouchernoteplaceholder3 as "dropVoucherNotePlaceholder" }